import React from 'react'
import styled from 'styled-components'

const PramonImg = styled.img`
  position: absolute;
`

export const Pramon = ({ widget: { id } }) => (
  <PramonImg src={`https://r.i0.cz/l.gif?s=pramon&v=1&e=view&t=${id}`} alt='Pramon'/>
)
